import { IEnumeration } from 'utility-js-enumeration';
import { PathTask } from './../builders/path_task_builder';

angular.module('data-ng-todos').factory('TaskStatusEnum', (Enumeration: IEnumeration, ItemPresenterEnum: any) => {
  return Enumeration('TaskStatusEnum', {
    ACTIVE: {
      noTasks: 'Yay! You have no tasks this week.',
      taskHeader(task: any) {
        let format;

        if (task.start_ts && ItemPresenterEnum.APPOINTMENT_REQUEST.key !== task._item.presenter.key) {
          format = task.start_ts.year() !== task.end_ts.year() ? 'MMM D, YYYY' : 'MMM D';
          return task.start_ts.format(format) + ' - ' + task.end_ts.format(format);
        } else {
          return 'By ' + task.end_ts.format('MMM D');
        }
      }
    },
    OVERDUE: {
      noTasks: "You don't have any overdue tasks.",
      taskHeader(task: PathTask) {
        const format = task.end_ts.year() !== moment().year() ? 'MMM D, YYYY' : 'MMM D';

        return 'Overdue on ' + task.end_ts.format(format);
      }
    },
    COMPLETED: {
      noTasks: "You don't have any completed tasks.",
      taskHeader(task: any) {
        return 'Completed on ' + task.status_changed_ts.format('MMM D');
      }
    },
    DISMISSED: {
      noTasks: "You don't have any dismissed tasks.",
      taskHeader(task: any) {
        return 'Dismissed on ' + task.status_changed_ts.format('MMM D');
      }
    },
    REMINDER: {
      noTasks: "You don't have any personal to-dos.",
      taskHeader(task: PathTask) {
        return '';
      }
    }
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/types/task_status_enum.ts